import CrystalIcon from "../game/image/Icons/Crystal.png";
import InterstellarMineralIcon from "../game/image/Icons/InterstellarMineral.png";
import BiomassIcon from "../game/image/Icons/Biomass.png";
import QuantumFoamIcon from "../game/image/Icons/QuantumFoam.png";
import NecrodermisIcon from "../game/image/Icons/Necrodermis.png";
import AlienFloralIcon from "../game/image/Icons/AlienFloral.png";
import SpiceMelangeIcon from "../game/image/Icons/SpiceMelange.png";
import TitaniumIcon from "../game/image/Icons/Titanium.png";
import CrystalDisabledIcon from "../game/image/Icons/CrystalDisabled.png";
import InterstellarMineralDisabledIcon from "../game/image/Icons/InterstellarMineralDisabled.png";
import BiomassDisabledIcon from "../game/image/Icons/BiomassDisabled.png";
import QuantumFoamDisabledIcon from "../game/image/Icons/QuantumFoamDisabled.png";
import NecrodermisDisabledIcon from "../game/image/Icons/NecrodermisDisabled.png";
import AlienFloralDisabledIcon from "../game/image/Icons/AlienFloralDisabled.png";
import SpiceMelangeDisabledIcon from "../game/image/Icons/SpiceMelangeDisabled.png";
import TitaniumDisabledIcon from "../game/image/Icons/TitaniumDisabled.png";
import LevelIcon from "../game/image/Icons/level.png";
import SpeedIcon from "../game/image/Icons/speed.png";
import EfficiencyIcon from "../game/image/Icons/efficiency.png";
import ProductivityIcon from "../game/image/Icons/productivity.png";
import Bot1 from "../game/image/CreatureBots/robot1.png";
import Bot2 from "../game/image/CreatureBots/robot2.png";
import Bot3 from "../game/image/CreatureBots/robot3.png";
import Bot4 from "../game/image/CreatureBots/robot4.png";
import IlluGenSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/IlluGen.png";
import EtherForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EtherForge.png";
import QuantumScribeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantumScribe.png";
import EvolviFySpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EvolviFy.png";
import QuantumFrostSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantumFrost.png";
import QuantumSurgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantumSurge.png";
import CyberPulseSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CyberPulse.png";
import NexuMaxSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NexuMax.png";
import QuantaForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantaForge.png";
import CrysTaraSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CrysTara.png";
import PlasmaShiftSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/PlasmaShift.png";
import AespaSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/Aespa.png";
import SwiftForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/SwiftForge.png";
import BioGenSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioGen.png";
import BioFusionSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioFusion.png";
import AstroMineSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/AstroMine.png";
import TitaniumBoostSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/TitaniumBoost.png";
import TTgenesisSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/TTgenesis.png";
import QuantumLeapSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantumLeap.png";
import SpicenRichSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/SpicenRich.png";
import BioSurgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioSurge.png";
import NeuroForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NeuroForge.png";
import SuperNovaSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/SuperNova.png";
import ResoNexSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/ResoNex.png";
import QuiFoamSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuiFoam.png";
import NovaBurstSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NovaBurst.png";
import StellarChargeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/StellarCharge.png";
import NexroVestSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NexroVest.png";
import PlasmaChargeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/PlasmaCharge.png";
import CogniFySpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CogniFy.png";
import BioHarvestSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioHarvest.png";
import AbracadabraSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/Abracadabra.png";
import CerebraSparkSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CerebraSpark.png";
import EnerGexSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EnerGex.png";
import MegaBoostSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/MegaBoost.png";
import NeuroChargeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NeuroCharge.png";
import StarForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/StarForge.png";
import EtherWeaveSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EtherWeave.png";
import FortiGenSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/FortiGen.png";
import BioCastSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioCast.png";
import FortiFyxSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/FortiFyx.png";
import FortivestSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/Fortivest.png";
import AstroChargeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/AstroCharge.png";
import BioSynthesisSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/BioSynthesis.png";
import NovaFluxSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NovaFlux.png";
import XenoFloralSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/XenoFloral.png";
import SynTitanSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/SynTitan.png";
import FoamTapSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/FoamTap.png";
import NanoWeaveSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NanoWeave.png";
import CrystaBloomSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CrystaBloom.png";
import EtherPulseSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EtherPulse.png";
import EnerPlexSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EnerPlex.png";
import EnerGateSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EnerGate.png";
import PlasmaForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/PlasmaForge.png";
import NexusFieldSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NexusField.png";
import StarlightForgeSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/StarlightForge.png";
import EnerFusionSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/EnerFusion.png";
import CogniMeltSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/CogniMelt.png";
import NexiMineSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/NexiMine.png";
import TitanBloomSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/TitanBloom.png";
import QuantumCoreSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/QuantumCore.png";
import XenoBloomSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/XenoBloom.png";
import StarLightSpriteSheet from "../game/image/Animations/Programs/SpriteSheets/StarLight.png";
import IlluGenIcon from "../game/image/Animations/Programs/Icons/IlluGen.png";
import EtherForgeIcon from "../game/image/Animations/Programs/Icons/EtherForge.png";
import QuantumScribeIcon from "../game/image/Animations/Programs/Icons/QuantumScribe.png";
import EvolviFyIcon from "../game/image/Animations/Programs/Icons/EvolviFy.png";
import QuantumFrostIcon from "../game/image/Animations/Programs/Icons/QuantumFrost.png";
import QuantumSurgeIcon from "../game/image/Animations/Programs/Icons/QuantumSurge.png";
import CyberPulseIcon from "../game/image/Animations/Programs/Icons/CyberPulse.png";
import NexuMaxIcon from "../game/image/Animations/Programs/Icons/NexuMax.png";
import QuantaForgeIcon from "../game/image/Animations/Programs/Icons/QuantaForge.png";
import CrysTaraIcon from "../game/image/Animations/Programs/Icons/CrysTara.png";
import PlasmaShiftIcon from "../game/image/Animations/Programs/Icons/PlasmaShift.png";
import AespaIcon from "../game/image/Animations/Programs/Icons/Aespa.png";
import SwiftForgeIcon from "../game/image/Animations/Programs/Icons/SwiftForge.png";
import BioGenIcon from "../game/image/Animations/Programs/Icons/BioGen.png";
import BioFusionIcon from "../game/image/Animations/Programs/Icons/BioFusion.png";
import AstroMineIcon from "../game/image/Animations/Programs/Icons/AstroMine.png";
import TitaniumBoostIcon from "../game/image/Animations/Programs/Icons/TitaniumBoost.png";
import TTgenesisIcon from "../game/image/Animations/Programs/Icons/TTgenesis.png";
import QuantumLeapIcon from "../game/image/Animations/Programs/Icons/QuantumLeap.png";
import SpicenRichIcon from "../game/image/Animations/Programs/Icons/SpicenRich.png";
import BioSurgeIcon from "../game/image/Animations/Programs/Icons/BioSurge.png";
import NeuroForgeIcon from "../game/image/Animations/Programs/Icons/NeuroForge.png";
import SuperNovaIcon from "../game/image/Animations/Programs/Icons/SuperNova.png";
import ResoNexIcon from "../game/image/Animations/Programs/Icons/ResoNex.png";
import QuiFoamIcon from "../game/image/Animations/Programs/Icons/QuiFoam.png";
import NovaBurstIcon from "../game/image/Animations/Programs/Icons/NovaBurst.png";
import StellarChargeIcon from "../game/image/Animations/Programs/Icons/StellarCharge.png";
import NexroVestIcon from "../game/image/Animations/Programs/Icons/NexroVest.png";
import PlasmaChargeIcon from "../game/image/Animations/Programs/Icons/PlasmaCharge.png";
import CogniFyIcon from "../game/image/Animations/Programs/Icons/CogniFy.png";
import BioHarvestIcon from "../game/image/Animations/Programs/Icons/BioHarvest.png";
import AbracadabraIcon from "../game/image/Animations/Programs/Icons/Abracadabra.png";
import CerebraSparkIcon from "../game/image/Animations/Programs/Icons/CerebraSpark.png";
import EnerGexIcon from "../game/image/Animations/Programs/Icons/EnerGex.png";
import MegaBoostIcon from "../game/image/Animations/Programs/Icons/MegaBoost.png";
import NeuroChargeIcon from "../game/image/Animations/Programs/Icons/NeuroCharge.png";
import StarForgeIcon from "../game/image/Animations/Programs/Icons/StarForge.png";
import EtherWeaveIcon from "../game/image/Animations/Programs/Icons/EtherWeave.png";
import FortiGenIcon from "../game/image/Animations/Programs/Icons/FortiGen.png";
import BioCastIcon from "../game/image/Animations/Programs/Icons/BioCast.png";
import FortiFyxIcon from "../game/image/Animations/Programs/Icons/FortiFyx.png";
import FortivestIcon from "../game/image/Animations/Programs/Icons/Fortivest.png";
import AstroChargeIcon from "../game/image/Animations/Programs/Icons/AstroCharge.png";
import BioSynthesisIcon from "../game/image/Animations/Programs/Icons/BioSynthesis.png";
import NovaFluxIcon from "../game/image/Animations/Programs/Icons/NovaFlux.png";
import XenoFloralIcon from "../game/image/Animations/Programs/Icons/XenoFloral.png";
import SynTitanIcon from "../game/image/Animations/Programs/Icons/SynTitan.png";
import FoamTapIcon from "../game/image/Animations/Programs/Icons/FoamTap.png";
import NanoWeaveIcon from "../game/image/Animations/Programs/Icons/NanoWeave.png";
import CrystaBloomIcon from "../game/image/Animations/Programs/Icons/CrystaBloom.png";
import EtherPulseIcon from "../game/image/Animations/Programs/Icons/EtherPulse.png";
import EnerPlexIcon from "../game/image/Animations/Programs/Icons/EnerPlex.png";
import EnerGateIcon from "../game/image/Animations/Programs/Icons/EnerGate.png";
import PlasmaForgeIcon from "../game/image/Animations/Programs/Icons/PlasmaForge.png";
import NexusFieldIcon from "../game/image/Animations/Programs/Icons/NexusField.png";
import StarlightForgeIcon from "../game/image/Animations/Programs/Icons/StarlightForge.png";
import EnerFusionIcon from "../game/image/Animations/Programs/Icons/EnerFusion.png";
import CogniMeltIcon from "../game/image/Animations/Programs/Icons/CogniMelt.png";
import NexiMineIcon from "../game/image/Animations/Programs/Icons/NexiMine.png";
import TitanBloomIcon from "../game/image/Animations/Programs/Icons/TitanBloom.png";
import QuantumCoreIcon from "../game/image/Animations/Programs/Icons/QuantumCore.png";
import XenoBloomIcon from "../game/image/Animations/Programs/Icons/XenoBloom.png";
import StarLightIcon from "../game/image/Animations/Programs/Icons/StarLight.png";
import bot8Spritesheet from "../game/image/Animations/Creatures/bot8.png";
import bot6Spritesheet from "../game/image/Animations/Creatures/bot6.png";
import bot1Spritesheet from "../game/image/Animations/Creatures/bot1.png";
import bot5_selectSpritesheet from "../game/image/Animations/Creatures/bot5_select.png";
import bot7Spritesheet from "../game/image/Animations/Creatures/bot7.png";
import bot7_selectSpritesheet from "../game/image/Animations/Creatures/bot7_select.png";
import bot3_selectSpritesheet from "../game/image/Animations/Creatures/bot3_select.png";
import bot1_selectSpritesheet from "../game/image/Animations/Creatures/bot1_select.png";
import bot2Spritesheet from "../game/image/Animations/Creatures/bot2.png";
import bot5Spritesheet from "../game/image/Animations/Creatures/bot5.png";
import bot8_selectSpritesheet from "../game/image/Animations/Creatures/bot8_select.png";
import bot4_selectSpritesheet from "../game/image/Animations/Creatures/bot4_select.png";
import bot4Spritesheet from "../game/image/Animations/Creatures/bot4.png";
import bot3Spritesheet from "../game/image/Animations/Creatures/bot3.png";
import bot6_selectSpritesheet from "../game/image/Animations/Creatures/bot6_select.png";
import bot2_selectSpritesheet from "../game/image/Animations/Creatures/bot2_select.png";

import { SERVER_TICK_TO_SECOND } from "../game/request";

export interface CreatureModel {
  attributes: AttributeAmountPair[];
  name: string;
  isLocked: boolean;
  creatureType: number;
  programIndexes: Array<number | null>;
  currentProgramIndex: number;
  isProgramStop: boolean;
  startTime: number;
  isStarting: boolean;
  cycleTime?: number; // 循环时间 (Cycle time)
}

export enum ProgramType {
  None,
  BioGen,
  CrysTara,
  AstroMine,
  CrystaBloom,
  EnerGex,
  StellarCharge,
  FoamTap,
  EnerFusion,
  EnerPlex,
  TTgenesis,
  QuantaForge,
  FortiFyx,
  SynTitan,
  SwiftForge,
  XenoFloral,
  TitaniumBoost,
  CerebraSpark,
  QuiFoam,
  AstroCharge,
  EnerGate,
  CogniMelt,
  NexiMine,
  XenoBloom,
  ResoNex,
  Fortivest,
  CogniFy,
  FortiGen,
  Abracadabra,
  MegaBoost,
  NexuMax,
  SpicenRich,
  EvolviFy,
  NexroVest,
  QuantumScribe,
  NeuroForge,
  CyberPulse,
  PlasmaShift,
  IlluGen,
  Aespa,
  SuperNova,
  NeuroCharge,
  QuantumLeap,
  BioSynthesis,
  PlasmaForge,
  NanoWeave,
  EtherPulse,
  StarLight,
  NovaBurst,
  BioHarvest,
  EtherForge,
  TitanBloom,
  QuantumFrost,
  BioFusion,
  NexusField,
  StarForge,
  PlasmaCharge,
  BioCast,
  EtherWeave,
  NovaFlux,
  QuantumCore,
  BioSurge,
  StarlightForge,
  QuantumSurge,
}

export interface Bid {
  bidprice: number;
  bidder: number[];
}

export interface ProgramModel {
  index: number;
  marketId: number;
  type: ProgramType;
  processingTime: number;
  resources: Array<ResourceAmountPair>;
  name: string;
  askPrice: number;
  sysPrice: number;
  owner: number[];
  bid: Bid | null;
}

export const emptyProgramModel: ProgramModel = {
  index: 0,
  marketId: 0,
  type: ProgramType.BioGen,
  processingTime: 0,
  resources: [],
  name: "",
  askPrice: 0,
  sysPrice: 0,
  owner: [],
  bid: null,
};

export function decodeProgram(
  programRaw: any,
  index = 0,
  askPrice = 0,
  sysPrice = 0,
  owner: number[] = [],
  bid: Bid | null = null
): ProgramModel {
  const { duration, attributes, marketid } = programRaw;
  const type = (index + 1) as ProgramType;
  const program: ProgramModel = {
    index,
    marketId: marketid,
    type,
    processingTime: duration * SERVER_TICK_TO_SECOND,
    resources: getResources(attributes).filter(
      (resource) => resource.amount !== 0
    ),
    name: getProgramName(type),
    askPrice,
    sysPrice,
    owner,
    bid,
  };

  return program;
}

export function decodePrograms(programRaws: any) {
  const programs: ProgramModel[] = [];
  for (let i = 0; i < programRaws.length; i++) {
    programs.push(decodeProgram(programRaws[i], i));
  }
  return programs;
}

export interface ProgramInfo {
  program: ProgramModel | null;
  index: number | null;
  remainTime: number;
  progress: number;
}

interface ProgramData {
  iconPath: string;
  spriteSheetPath: string;
}

const programDatas: Record<ProgramType, ProgramData> = {
  [ProgramType.None]: {
    iconPath: "",
    spriteSheetPath: "",
  },
  [ProgramType.IlluGen]: {
    iconPath: IlluGenIcon,
    spriteSheetPath: IlluGenSpriteSheet,
  },
  [ProgramType.EtherForge]: {
    iconPath: EtherForgeIcon,
    spriteSheetPath: EtherForgeSpriteSheet,
  },
  [ProgramType.QuantumScribe]: {
    iconPath: QuantumScribeIcon,
    spriteSheetPath: QuantumScribeSpriteSheet,
  },
  [ProgramType.EvolviFy]: {
    iconPath: EvolviFyIcon,
    spriteSheetPath: EvolviFySpriteSheet,
  },
  [ProgramType.QuantumFrost]: {
    iconPath: QuantumFrostIcon,
    spriteSheetPath: QuantumFrostSpriteSheet,
  },
  [ProgramType.QuantumSurge]: {
    iconPath: QuantumSurgeIcon,
    spriteSheetPath: QuantumSurgeSpriteSheet,
  },
  [ProgramType.CyberPulse]: {
    iconPath: CyberPulseIcon,
    spriteSheetPath: CyberPulseSpriteSheet,
  },
  [ProgramType.NexuMax]: {
    iconPath: NexuMaxIcon,
    spriteSheetPath: NexuMaxSpriteSheet,
  },
  [ProgramType.QuantaForge]: {
    iconPath: QuantaForgeIcon,
    spriteSheetPath: QuantaForgeSpriteSheet,
  },
  [ProgramType.CrysTara]: {
    iconPath: CrysTaraIcon,
    spriteSheetPath: CrysTaraSpriteSheet,
  },
  [ProgramType.PlasmaShift]: {
    iconPath: PlasmaShiftIcon,
    spriteSheetPath: PlasmaShiftSpriteSheet,
  },
  [ProgramType.Aespa]: {
    iconPath: AespaIcon,
    spriteSheetPath: AespaSpriteSheet,
  },
  [ProgramType.SwiftForge]: {
    iconPath: SwiftForgeIcon,
    spriteSheetPath: SwiftForgeSpriteSheet,
  },
  [ProgramType.BioGen]: {
    iconPath: BioGenIcon,
    spriteSheetPath: BioGenSpriteSheet,
  },
  [ProgramType.BioFusion]: {
    iconPath: BioFusionIcon,
    spriteSheetPath: BioFusionSpriteSheet,
  },
  [ProgramType.AstroMine]: {
    iconPath: AstroMineIcon,
    spriteSheetPath: AstroMineSpriteSheet,
  },
  [ProgramType.TitaniumBoost]: {
    iconPath: TitaniumBoostIcon,
    spriteSheetPath: TitaniumBoostSpriteSheet,
  },
  [ProgramType.TTgenesis]: {
    iconPath: TTgenesisIcon,
    spriteSheetPath: TTgenesisSpriteSheet,
  },
  [ProgramType.QuantumLeap]: {
    iconPath: QuantumLeapIcon,
    spriteSheetPath: QuantumLeapSpriteSheet,
  },
  [ProgramType.SpicenRich]: {
    iconPath: SpicenRichIcon,
    spriteSheetPath: SpicenRichSpriteSheet,
  },
  [ProgramType.BioSurge]: {
    iconPath: BioSurgeIcon,
    spriteSheetPath: BioSurgeSpriteSheet,
  },
  [ProgramType.NeuroForge]: {
    iconPath: NeuroForgeIcon,
    spriteSheetPath: NeuroForgeSpriteSheet,
  },
  [ProgramType.SuperNova]: {
    iconPath: SuperNovaIcon,
    spriteSheetPath: SuperNovaSpriteSheet,
  },
  [ProgramType.ResoNex]: {
    iconPath: ResoNexIcon,
    spriteSheetPath: ResoNexSpriteSheet,
  },
  [ProgramType.QuiFoam]: {
    iconPath: QuiFoamIcon,
    spriteSheetPath: QuiFoamSpriteSheet,
  },
  [ProgramType.NovaBurst]: {
    iconPath: NovaBurstIcon,
    spriteSheetPath: NovaBurstSpriteSheet,
  },
  [ProgramType.StellarCharge]: {
    iconPath: StellarChargeIcon,
    spriteSheetPath: StellarChargeSpriteSheet,
  },
  [ProgramType.NexroVest]: {
    iconPath: NexroVestIcon,
    spriteSheetPath: NexroVestSpriteSheet,
  },
  [ProgramType.PlasmaCharge]: {
    iconPath: PlasmaChargeIcon,
    spriteSheetPath: PlasmaChargeSpriteSheet,
  },
  [ProgramType.CogniFy]: {
    iconPath: CogniFyIcon,
    spriteSheetPath: CogniFySpriteSheet,
  },
  [ProgramType.BioHarvest]: {
    iconPath: BioHarvestIcon,
    spriteSheetPath: BioHarvestSpriteSheet,
  },
  [ProgramType.Abracadabra]: {
    iconPath: AbracadabraIcon,
    spriteSheetPath: AbracadabraSpriteSheet,
  },
  [ProgramType.CerebraSpark]: {
    iconPath: CerebraSparkIcon,
    spriteSheetPath: CerebraSparkSpriteSheet,
  },
  [ProgramType.EnerGex]: {
    iconPath: EnerGexIcon,
    spriteSheetPath: EnerGexSpriteSheet,
  },
  [ProgramType.MegaBoost]: {
    iconPath: MegaBoostIcon,
    spriteSheetPath: MegaBoostSpriteSheet,
  },
  [ProgramType.NeuroCharge]: {
    iconPath: NeuroChargeIcon,
    spriteSheetPath: NeuroChargeSpriteSheet,
  },
  [ProgramType.StarForge]: {
    iconPath: StarForgeIcon,
    spriteSheetPath: StarForgeSpriteSheet,
  },
  [ProgramType.EtherWeave]: {
    iconPath: EtherWeaveIcon,
    spriteSheetPath: EtherWeaveSpriteSheet,
  },
  [ProgramType.FortiGen]: {
    iconPath: FortiGenIcon,
    spriteSheetPath: FortiGenSpriteSheet,
  },
  [ProgramType.BioCast]: {
    iconPath: BioCastIcon,
    spriteSheetPath: BioCastSpriteSheet,
  },
  [ProgramType.FortiFyx]: {
    iconPath: FortiFyxIcon,
    spriteSheetPath: FortiFyxSpriteSheet,
  },
  [ProgramType.Fortivest]: {
    iconPath: FortivestIcon,
    spriteSheetPath: FortivestSpriteSheet,
  },
  [ProgramType.AstroCharge]: {
    iconPath: AstroChargeIcon,
    spriteSheetPath: AstroChargeSpriteSheet,
  },
  [ProgramType.BioSynthesis]: {
    iconPath: BioSynthesisIcon,
    spriteSheetPath: BioSynthesisSpriteSheet,
  },
  [ProgramType.NovaFlux]: {
    iconPath: NovaFluxIcon,
    spriteSheetPath: NovaFluxSpriteSheet,
  },
  [ProgramType.XenoFloral]: {
    iconPath: XenoFloralIcon,
    spriteSheetPath: XenoFloralSpriteSheet,
  },
  [ProgramType.SynTitan]: {
    iconPath: SynTitanIcon,
    spriteSheetPath: SynTitanSpriteSheet,
  },
  [ProgramType.FoamTap]: {
    iconPath: FoamTapIcon,
    spriteSheetPath: FoamTapSpriteSheet,
  },
  [ProgramType.NanoWeave]: {
    iconPath: NanoWeaveIcon,
    spriteSheetPath: NanoWeaveSpriteSheet,
  },
  [ProgramType.CrystaBloom]: {
    iconPath: CrystaBloomIcon,
    spriteSheetPath: CrystaBloomSpriteSheet,
  },
  [ProgramType.EtherPulse]: {
    iconPath: EtherPulseIcon,
    spriteSheetPath: EtherPulseSpriteSheet,
  },
  [ProgramType.EnerPlex]: {
    iconPath: EnerPlexIcon,
    spriteSheetPath: EnerPlexSpriteSheet,
  },
  [ProgramType.EnerGate]: {
    iconPath: EnerGateIcon,
    spriteSheetPath: EnerGateSpriteSheet,
  },
  [ProgramType.PlasmaForge]: {
    iconPath: PlasmaForgeIcon,
    spriteSheetPath: PlasmaForgeSpriteSheet,
  },
  [ProgramType.NexusField]: {
    iconPath: NexusFieldIcon,
    spriteSheetPath: NexusFieldSpriteSheet,
  },
  [ProgramType.StarlightForge]: {
    iconPath: StarlightForgeIcon,
    spriteSheetPath: StarlightForgeSpriteSheet,
  },
  [ProgramType.EnerFusion]: {
    iconPath: EnerFusionIcon,
    spriteSheetPath: EnerFusionSpriteSheet,
  },
  [ProgramType.CogniMelt]: {
    iconPath: CogniMeltIcon,
    spriteSheetPath: CogniMeltSpriteSheet,
  },
  [ProgramType.NexiMine]: {
    iconPath: NexiMineIcon,
    spriteSheetPath: NexiMineSpriteSheet,
  },
  [ProgramType.TitanBloom]: {
    iconPath: TitanBloomIcon,
    spriteSheetPath: TitanBloomSpriteSheet,
  },
  [ProgramType.QuantumCore]: {
    iconPath: QuantumCoreIcon,
    spriteSheetPath: QuantumCoreSpriteSheet,
  },
  [ProgramType.XenoBloom]: {
    iconPath: XenoBloomIcon,
    spriteSheetPath: XenoBloomSpriteSheet,
  },
  [ProgramType.StarLight]: {
    iconPath: StarLightIcon,
    spriteSheetPath: StarLightSpriteSheet,
  },
};

interface CreatureImageData {
  iconPath: string;
  spriteSheetPath: string;
  selectSpriteSheetPath: string;
}

const emptyCreatureImageData: CreatureImageData = {
  iconPath: "",
  spriteSheetPath: "",
  selectSpriteSheetPath: "",
};

interface CreatureLocationData {
  left: number;
  top: number;
}

const emptyCreatureLocationData: CreatureLocationData = {
  left: 0,
  top: 0,
};

const creatureImageDatas: CreatureImageData[] = [
  {
    iconPath: Bot1,
    spriteSheetPath: bot1Spritesheet,
    selectSpriteSheetPath: bot1_selectSpritesheet,
  },
  {
    iconPath: Bot2,
    spriteSheetPath: bot2Spritesheet,
    selectSpriteSheetPath: bot2_selectSpritesheet,
  },
  {
    iconPath: Bot3,
    spriteSheetPath: bot3Spritesheet,
    selectSpriteSheetPath: bot3_selectSpritesheet,
  },
  {
    iconPath: Bot4,
    spriteSheetPath: bot4Spritesheet,
    selectSpriteSheetPath: bot4_selectSpritesheet,
  },
  {
    iconPath: Bot1,
    spriteSheetPath: bot5Spritesheet,
    selectSpriteSheetPath: bot5_selectSpritesheet,
  },
  {
    iconPath: Bot2,
    spriteSheetPath: bot6Spritesheet,
    selectSpriteSheetPath: bot6_selectSpritesheet,
  },
  {
    iconPath: Bot3,
    spriteSheetPath: bot7Spritesheet,
    selectSpriteSheetPath: bot7_selectSpritesheet,
  },
  {
    iconPath: Bot4,
    spriteSheetPath: bot8Spritesheet,
    selectSpriteSheetPath: bot8_selectSpritesheet,
  },
];

const creatureLocationDatas: CreatureLocationData[] = [
  // planet 1
  {
    left: 210,
    top: 530,
  },
  {
    left: 880,
    top: 280,
  },
  {
    left: 1320,
    top: 390,
  },
  {
    left: 1100,
    top: 480,
  },
  {
    left: 1160,
    top: 140,
  },
  {
    left: 300,
    top: 270,
  },
  {
    left: 590,
    top: 380,
  },
  {
    left: 680,
    top: 480,
  },

  // planet 2
  {
    left: 170,
    top: 530,
  },
  {
    left: 960,
    top: 340,
  },
  {
    left: 680,
    top: 410,
  },
  {
    left: 1260,
    top: 570,
  },
  {
    left: 1450,
    top: 350,
  },
  {
    left: 400,
    top: 550,
  },
  {
    left: 620,
    top: 250,
  },
  {
    left: 900,
    top: 480,
  },
];

export enum ResourceType {
  Crystal,
  InterstellarMineral,
  Biomass,
  QuantumFoam,
  Necrodermis,
  AlienFloral,
  SpiceMelange,
  Titanium,
}

export interface ResourceAmountPair {
  type: ResourceType;
  amount: number;
}

export enum AttributeType {
  Level,
  Speed,
  Efficiency,
  Productivity,
}

export interface AttributeAmountPair {
  type: AttributeType;
  amount: number;
}

export interface FilterModel {
  dict: { [key in ResourceType]?: boolean };
}

export enum GuideType {
  None,
  First,
}

interface ResourceData {
  name: string;
  description: string;
  iconPath: string;
  disableIconPath: string;
}

export interface MarketTabData {
  programs: ProgramModel[];
  programCount: number;
}

export const emptyMarketTabData: MarketTabData = {
  programs: [],
  programCount: -1,
};

export interface MarketPageData {
  programs: ProgramModel[];
  page: number;
  pageCount: number;
}

export const emptyNuggetPageData: MarketPageData = {
  programs: [],
  page: 0,
  pageCount: 0,
};

const resourceDatas: Record<ResourceType, ResourceData> = {
  [ResourceType.Crystal]: {
    name: "Crystal",
    description: "This is Crystal",
    iconPath: CrystalIcon,
    disableIconPath: CrystalDisabledIcon,
  },
  [ResourceType.InterstellarMineral]: {
    name: "Interstellar Mineral",
    description: "This is Interstellar Mineral",
    iconPath: InterstellarMineralIcon,
    disableIconPath: InterstellarMineralDisabledIcon,
  },
  [ResourceType.Biomass]: {
    name: "Biomass",
    description: "This is Biomass",
    iconPath: BiomassIcon,
    disableIconPath: BiomassDisabledIcon,
  },
  [ResourceType.QuantumFoam]: {
    name: "Quantum Foam",
    description: "This is Quantum Foam",
    iconPath: QuantumFoamIcon,
    disableIconPath: QuantumFoamDisabledIcon,
  },
  [ResourceType.Necrodermis]: {
    name: "Necrodermis",
    description: "This is Necrodermis",
    iconPath: NecrodermisIcon,
    disableIconPath: NecrodermisDisabledIcon,
  },
  [ResourceType.AlienFloral]: {
    name: "Alien Floral",
    description: "This is Alien Floral",
    iconPath: AlienFloralIcon,
    disableIconPath: AlienFloralDisabledIcon,
  },
  [ResourceType.SpiceMelange]: {
    name: "Spice Melange",
    description: "This is Spice Melange",
    iconPath: SpiceMelangeIcon,
    disableIconPath: SpiceMelangeDisabledIcon,
  },
  [ResourceType.Titanium]: {
    name: "Titanium",
    description: "This is Titanium",
    iconPath: TitaniumIcon,
    disableIconPath: TitaniumDisabledIcon,
  },
};

interface AttributeData {
  name: string;
  description: string;
  iconPath: string;
}

const attributeDatas: Record<AttributeType, AttributeData> = {
  [AttributeType.Level]: {
    name: "Level",
    description: "This is Level",
    iconPath: LevelIcon,
  },
  [AttributeType.Speed]: {
    name: "Speed",
    description: "This is Speed",
    iconPath: SpeedIcon,
  },
  [AttributeType.Efficiency]: {
    name: "Efficiency",
    description: "This is Efficiency",
    iconPath: EfficiencyIcon,
  },
  [AttributeType.Productivity]: {
    name: "Productivity",
    description: "This is Productivity",
    iconPath: ProductivityIcon,
  },
};

export const resourceTypes = Object.values(ResourceType).filter(
  (value) => typeof value === "number"
) as ResourceType[];

export const attributeTypes = Object.values(AttributeType).filter(
  (value) => typeof value === "number"
) as AttributeType[];

export const emptyResources = resourceTypes.map((type) => ({
  type,
  amount: 0,
}));

export const emptyAttributes = attributeTypes.map((type) => ({
  type,
  amount: 0,
}));

export const emptyCreature: CreatureModel = {
  attributes: emptyAttributes,
  name: "",
  isLocked: false,
  creatureType: -1,
  programIndexes: [null, null, null, null, null, null, null, null],
  currentProgramIndex: 0,
  isProgramStop: false,
  startTime: 0,
  isStarting: false,
};

export function getCreatingCreature(creatureType: number): CreatureModel {
  return {
    attributes: emptyAttributes,
    name: "Creating",
    isLocked: false,
    creatureType: creatureType,
    programIndexes: [null, null, null, null, null, null, null, null],
    currentProgramIndex: 0,
    isProgramStop: false,
    startTime: 0,
    isStarting: false,
  };
}

export const allResourcesToggleFilter: FilterModel = {
  dict: resourceTypes.reduce((acc, type) => {
    acc[type] = false;
    return acc;
  }, {} as { [key in ResourceType]?: boolean }),
};

export function getResources(array: Array<number>) {
  return resourceTypes.map((type, index) => ({
    type,
    amount: array[index] ?? 0,
  }));
}

export function getAttributes(array: Array<number>) {
  return attributeTypes.map((type, index) => ({
    type,
    amount: array[index],
  }));
}

export function getResourceIconPath(type: ResourceType): string {
  return resourceDatas[type].iconPath;
}

export function getResourceDisabledIconPath(type: ResourceType): string {
  return resourceDatas[type].disableIconPath;
}

export function getAttributeIconPath(type: AttributeType): string {
  return attributeDatas[type].iconPath;
}

export function getResourceNameText(type: ResourceType): string {
  return resourceDatas[type].name;
}

export function getAttributeNameText(type: AttributeType): string {
  return attributeDatas[type].name;
}

export function getResourceDescriptionText(type: ResourceType): string {
  return resourceDatas[type].description;
}

export function getAttributeDescriptionText(type: AttributeType): string {
  return attributeDatas[type].description;
}

export function getNumberAbbr(num: number): string {
  const abbr = [
    { value: 1e12, suffix: "T" },
    { value: 1e9, suffix: "B" },
    { value: 1e6, suffix: "M" },
    { value: 1e3, suffix: "K" },
  ];
  const sign = num < 0 ? "-" : "";

  num = Math.abs(num);
  for (let i = 0; i < abbr.length; i++) {
    if (num >= abbr[i].value) {
      let formattedNumber = (num / abbr[i].value).toFixed(1);
      if (formattedNumber.endsWith(".0")) {
        formattedNumber = formattedNumber.slice(0, -2);
      }
      return sign + formattedNumber + abbr[i].suffix;
    }
  }

  return sign + num.toString();
}

export function getProgramName(type: ProgramType): string {
  return ProgramType[type];
}

export function getProgramIconPath(type: ProgramType): string {
  return programDatas[type].iconPath;
}

export function getProgramSpriteSheetPath(type: ProgramType): string {
  return programDatas[type].spriteSheetPath;
}

export function getCreatureIconPath(creatureType: number): string {
  return creatureType == -1
    ? emptyCreatureImageData.iconPath
    : creatureImageDatas[creatureType % creatureImageDatas.length].iconPath;
}

export function getCreatureSpriteSheetPath(
  creatureType: number,
  isSelect: boolean
): string {
  return creatureType == -1
    ? emptyCreatureImageData.spriteSheetPath
    : isSelect
    ? creatureImageDatas[creatureType % creatureImageDatas.length]
        .selectSpriteSheetPath
    : creatureImageDatas[creatureType % creatureImageDatas.length]
        .spriteSheetPath;
}

export function getCreatureLeft(creatureType: number): number {
  return creatureType == -1
    ? emptyCreatureLocationData.left
    : creatureLocationDatas[creatureType % creatureLocationDatas.length].left;
}

export function getCreatureTop(creatureType: number): number {
  return creatureType == -1
    ? emptyCreatureLocationData.top
    : creatureLocationDatas[creatureType % creatureLocationDatas.length].top;
}

export interface ConfirmPopupInfo {
  title: string;
  description: string;
  isError: boolean;
}

export const emptyConfirmPopupInfo: ConfirmPopupInfo = {
  title: "",
  description: "",
  isError: false,
};

export const expToLevelUp = 100;
export const redeemEnergyAmount = 10;
export const redeemEnergyTitaniumCost = 1;
